import breakpoints from '@commons/utils/screen/breakpoints';

function isMobile(width) {
  if (!width) return false;
  return width < breakpoints.MOBILE;
}

export default isMobile;
